import { useState } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import PageTitle from "utils/PageTitle";
import { selectUserPersonalInformation } from "store/reducers/user/UserAccountSlice";
import StepperComponent from "../OnboardingStepper";
import SideMenuLayout from "../SideMenuLayout";
import { PATHS } from "constants/pathConstants";
import ProfileForm, {
  type ProfileFormFields
} from "components/v3/forms/ProfileForm";

const ProfilePage = () => {
  PageTitle("Your Profile");
  const history = useHistory();
  const memberInformation = useSelector(selectUserPersonalInformation);
  const [formFieldValues, setFormFieldValues] = useState<ProfileFormFields>(
    {} as ProfileFormFields
  );

  const handleFormFieldsUpdated = (formFields: ProfileFormFields) => {
    setFormFieldValues(formFields);
  };

  const handleSubmitted = (formFields: ProfileFormFields) => {
    const updatedEmail = formFields?.email || "";
    const changedContactEmail = memberInformation.email !== updatedEmail;

    if (changedContactEmail) {
      //updateEmail(formFields.email);
    }

    history.push(PATHS.LANDING_PAGE);
  };

  return (
    <SideMenuLayout
      onboardingStepper={
        <StepperComponent
          activeStepIndex={8}
          newPreferredName={formFieldValues.preferredName}
        />
      }
    >
      <ProfileForm
        onFormFieldsUpdated={handleFormFieldsUpdated}
        onSubmitted={handleSubmitted}
      />
    </SideMenuLayout>
  );
};

export default ProfilePage;
